import { Controller } from '@hotwired/stimulus';

export default class TabController extends Controller {
  static targets = ['tab', 'pane', 'scroll', 'wrapper'];
  static values = {
    shouldReload: Boolean,
  };

  connect() {
    this.tabTargets.forEach((tab) => {
      tab.addEventListener('click', this.handleTabClick);
    });
    this.scrollTarget.addEventListener('scroll', this.handleScroll);
    window.addEventListener('popstate', this.handlePopState);
  }

  disconnect() {
    this.tabTargets.forEach((tab) => {
      tab.removeEventListener('click', this.handleTabClick);
    });
    this.scrollTarget.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('popstate', this.handlePopState);
  }

  handleTabClick = (event) => {
    event.preventDefault();
    const clickedTab = event.currentTarget;
    this.activateTab(clickedTab.dataset.category);
    if (this.shouldReloadValue) {
      window.location = clickedTab.getAttribute('href');
      return;
    }
    history.pushState(null, '', clickedTab.getAttribute('href'));
  };

  handlePopState = () => {
    const matchingTab = this.tabTargets.find((tab) => tab.getAttribute('href') === window.location.pathname);

    if (matchingTab) {
      this.activateTab(matchingTab.dataset.category);
    }
  };

  activateTab(category) {
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.category === category;
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.paneTargets.forEach((pane) => {
      const isActive = pane.id === category;
      pane.classList.toggle('show', isActive);
      pane.classList.toggle('active', isActive);
    });
  }

  handleScroll = () => {
    const scrollElement = this.scrollTarget;
    const hasReachedEnd = scrollElement.scrollLeft + scrollElement.clientWidth >= scrollElement.scrollWidth - 1;

    this.wrapperTarget.classList.toggle('wrapper-end', hasReachedEnd);
  };
}
